import { render, staticRenderFns } from "./barCode2.vue?vue&type=template&id=028d5b5c&"
import script from "./barCode2.vue?vue&type=script&lang=js&"
export * from "./barCode2.vue?vue&type=script&lang=js&"
import style0 from "./barCode2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports